import gql from "graphql-tag";

const VALIDATE_ICC = gql`
    query ValidateIcc($icc: ID!, $offer_id: ID!) {
        validate_icc(icc: $icc, offer_id: $offer_id) {
            status,
            title,
            error,
        }
    }
`;

const SNOC_INVENTORY_CHECK = gql`
    query SnocInventoryCheck($shop_code: String!, $serial_numbers: String!) {
        snoc_inventory_check(shop_code: $shop_code, serial_numbers: $serial_numbers) {
            available,
            not_available,
            response_code,
            response_message
        }
    }
`;

export {
	VALIDATE_ICC,
    SNOC_INVENTORY_CHECK
};
